document.addEventListener("DOMContentLoaded", () => {

  const targetElement = document.querySelector('.js-locator');
  console.log('inited');

  let inputValue

  // if body contains class "body--stockists" then set var inputValue to '[value="20453"]' else set to '[value="yyyy"]'

  if (document.body.classList.contains('body--stockists')) {
    inputValue = '[value="20449"]'
  }
  else {
    inputValue = '[value="20453"]'
  }

  targetElement.style.opacity = "0.5";
  targetElement.style.pointerEvents = "none";
  let clicked = false;



  const observer = new MutationObserver(function (mutationsList, observer) {

    if (mutationsList.length > 0) {

      mutationsList.forEach(mutation => {

        if (mutation.target.classList.contains('stockist-result-list')) {

          if (clicked) return;

          //  stop observing
          const spaInput = document.querySelector(inputValue);
          //mark input checked

          console.log(spaInput);
          observer.disconnect();

          setTimeout(() => {
            spaInput.parentElement.click()
            clicked = true;
            targetElement.style.opacity = "1";
            targetElement.style.pointerEvents = "all";
            console.log('checked');

            if (inputValue == '[value="20453"]') {
              console.log('spa');

              document.querySelectorAll('.stockist-search-filter-checkbox').forEach(el => el.style.display = "none");



            } else {
              console.log('stockist');
              document.querySelectorAll('.stockist-search-filter-checkbox')[2].style.display = "none";
            }


          }, 2000);


        }
      });
    }
  });

  const config = { childList: true, subtree: true };
  observer.observe(targetElement, config);




});

